import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, MemoryRouter } from 'react-router-dom';
import AppRouter from './Router/appRouter';
import routePaths from './shared/paths.config';

const App = ({ libParam }) => {
  const { preferredName } = routePaths;

  return (
    <>
      {libParam ? (
        <MemoryRouter initialEntries={[preferredName]}>
          <AppRouter libParam={libParam} />
        </MemoryRouter>
      ) : (
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      )}
    </>
  );
};

App.propTypes = {
  libParam: PropTypes.object
};

App.defaultProps = {
  libParam: null
};

export default App;
